module.exports = __webpack_public_path__ + "img/User Experience.fad6da35.png";